// Import: Middleware Action & Custom Types
import { CLEAN_DOWNLOAD_PDF, CLEAN_DOWNLOAD_PDF_ERROR } from '_models/redux/types';

// Action function
export const cleanDownloadPdf = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_DOWNLOAD_PDF,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_DOWNLOAD_PDF_ERROR,
    });
  }
};
